import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import toast, { Toaster } from 'react-hot-toast';
import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/system';
import axios from '../../../../axios';
import { Box as MuiBox, Grid, MenuItem, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { CREATE_ITEM, DELETE_ITEM, REORDER_ITEMS, UPDATE_ITEM } from '../../../api';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import DraggableDataGrid from '../draggableDataGrid';
import { DragIndicator } from '@mui/icons-material';
import { ITEM_ELIGIBILITY_OPTIONS } from '../../../utils/bookingItemEligibility';

function UpdatePackageItem({
  open,
  handleClose,
  packageData,
  retrieveService,
  selectedPackageData,
}) {
  const initialState = {
    items: [
      {
        title: '',
        time_hrs: '',
        price: '',
        discount_percent: '',
        discount_type: 'fixed',
        discount_value: '',
        eligibility_type: 'all',
        package: '',
        order: null,
      },
    ],
  };
  const [formData, setFormData] = useState(initialState);
  const [validated, setValidated] = useState([true]);
  const [readOnly, setReadOnly] = useState([false]);
  useEffect(() => {
    let arr = [];
    let validateArr = [];
    let readOnlyArr = [];
    if (open && Object.keys(selectedPackageData).length > 0) {
      if (selectedPackageData?.item?.length > 0) {
        selectedPackageData?.item?.slice()?.sort((a, b) => a.order - b.order)?.forEach((item) => {
          arr.push({
            created_at: item?.created_at,
            discount_percent: `${item?.discount_percent ?? 0}`,
            discount_type: item?.discount_type || 'percentage',
            discount_value: `${item?.discount_value ?? item?.discount_amount ?? item?.discount_percent ?? 0}`,
            discount_amount: `${item?.discount_amount ?? 0}`,
            eligibility_type: item?.eligibility_type || 'all',
            id: item?.id,
            price: item?.price,
            time_hrs: item?.time_hrs,
            order: item?.order,
            title: item?.title,
            updated_at: item?.updated_at,
          });
          validateArr.push(true);
          readOnlyArr.push(true);
        });
        setValidated(validateArr);
        setReadOnly(readOnlyArr);
        setFormData({ items: arr });
      } else {
        setValidated([true]);
        setReadOnly([false]);
        setFormData({
          items: [
            {
              title: '',
              time_hrs: '',
              price: '',
              order: 1,
              discount_percent: '',
              discount_type: 'fixed',
              discount_value: '',
              eligibility_type: 'all',
              package: packageData?.id,
            },
          ],
        });
      }
    }
  }, [open, packageData?.id, selectedPackageData]);

  const handleFormData = (field, value, index) => {
    setFormData((prev) => {
      const nextItems = [...(prev?.items || [])];
      const currentItem = nextItems[index] || {};
      nextItems[index] = {
        ...currentItem,
        [field]: value,
      };
      return { ...prev, items: nextItems };
    });
  };
  const handleDiscountValue = (value, index) => {
    setFormData((prev) => {
      const nextItems = [...(prev?.items || [])];
      const currentItem = nextItems[index] || {};
      nextItems[index] = {
        ...currentItem,
        discount_value: value,
        discount_percent: currentItem.discount_type === 'percentage' ? value : '0',
        discount_amount: currentItem.discount_type === 'fixed' ? value : '0',
      };
      return { ...prev, items: nextItems };
    });
  };
  const handleDiscountType = (discountType, index) => {
    if (!discountType || readOnly[index]) return;
    setFormData((prev) => {
      const nextItems = [...(prev?.items || [])];
      const currentItem = nextItems[index] || {};
      nextItems[index] = {
        ...currentItem,
        discount_type: discountType,
        discount_percent: discountType === 'percentage' ? currentItem.discount_value : '0',
        discount_amount: discountType === 'fixed' ? currentItem.discount_value : '0',
      };
      return { ...prev, items: nextItems };
    });
  };
  const saveItem = (index, item) => {
    const dupObj = { ...formData };
    if (validateVendorForm(index)) {
      const dupReadOnly = [...readOnly];
      if (item?.id) {
        toast.promise(
          axios.put(`${UPDATE_ITEM}`, item, {
            headers: { 'Content-Type': 'application/json' },
          }),
          {
            loading: () => {
              return `Updating Item!`;
            },
            success: (res) => {
              dupObj.items[index] = {
                ...item,
                ...res?.data?.data,
                discount_type: res?.data?.data?.discount_type || item?.discount_type,
                discount_value: res?.data?.data?.discount_value ?? item?.discount_value,
              };
              dupReadOnly[index] = true;
              setFormData(dupObj);
              setReadOnly(dupReadOnly);
              return res?.data?.message;
            },
            error: (err) => {
              return err?.message;
            },
          }
        );
      } else {
        toast.promise(
          axios.post(`${CREATE_ITEM}`, item, {
            headers: { 'Content-Type': 'application/json' },
          }),
          {
            loading: () => {
              return `Creating Item!`;
            },
            success: (res) => {
              dupObj.items[index] = {
                ...item,
                ...res?.data?.data,
                discount_type: res?.data?.data?.discount_type || item?.discount_type,
                discount_value: res?.data?.data?.discount_value ?? item?.discount_value,
              };
              dupReadOnly[index] = true;
              setFormData(dupObj);
              setReadOnly(dupReadOnly);
              return res?.data?.message;
            },
            error: (err) => {
              return err?.message;
            },
          }
        );
      }
    }
  };
  const validateVendorForm = (index) => {
    if (
      formData.items[index]?.title === '' ||
      formData.items[index]?.time_hrs === '' ||
      formData.items[index]?.time_hrs?.includes('-') ||
      formData.items[index]?.price === '' ||
      formData.items[index]?.price?.includes('-') ||
      formData.items[index]?.discount_value === '' ||
      formData.items[index]?.discount_value?.includes('-') ||
      (formData.items[index]?.discount_type === 'percentage' && Number(formData.items[index]?.discount_value) > 100)
    ) {
      const dupValidate = [...validated];
      dupValidate[index] = false;
      setValidated(dupValidate);
      return false;
    }
    const dupValidate = [...validated];
    dupValidate[index] = true;
    setValidated(dupValidate);
    return true;
  };

  const addMoreItems = () => {
    setFormData((prev) => {
      const nextItems = [...(prev?.items || [])];
      nextItems.push({
        title: '',
        time_hrs: '',
        price: '',
        discount_percent: '',
        discount_type: 'fixed',
        discount_value: '',
        eligibility_type: 'all',
        order: nextItems.length + 1,
        package: packageData?.id,
      });
      return { ...prev, items: nextItems };
    });
    setValidated((prev) => [...prev, true]);
    setReadOnly((prev) => [...prev, false]);
  };
  const deleteItems = (index, item) => {
    const dupObj = { ...formData };
    const dupValidate = [...validated];
    const dupReadOnly = [...readOnly];
    if (item?.id) {
      toast.promise(
        axios.delete(`${DELETE_ITEM}/${item?.id}`, {
          headers: { 'Content-Type': 'application/json' },
        }),
        {
          loading: () => {
            return `Deleting Item!`;
          },
          success: (res) => {
            dupObj.items.splice(index, 1);
            dupValidate.splice(index, 1);
            dupReadOnly.splice(index, 1);
            setFormData(dupObj);
            setValidated(dupValidate);
            setReadOnly(dupReadOnly);
            return res?.data?.message;
          },
          error: (err) => {
            return err?.message;
          },
        }
      );
    } else {
      dupObj.items.splice(index, 1);
      dupValidate.splice(index, 1);
      dupReadOnly.splice(index, 1);
      setFormData(dupObj);
      setValidated(dupValidate);
      setReadOnly(dupReadOnly);
    }
  };
  const readOnlyOff = (index) => {
    const dupReadOnly = [...readOnly];
    dupReadOnly[index] = false;
    setReadOnly(dupReadOnly);
  };
  const handleListUpdate = (newOrderedList) => {
    if (newOrderedList?.length) {
        const formattedList = newOrderedList.map((z) => {
          return {
            item_id: z?.id,
            order: z?.order,
          };
        });
        toast.promise(
          axios.put(`${REORDER_ITEMS}/${selectedPackageData?.id}/`, formattedList, {
            headers: { 'Content-Type': 'application/json' },
          }),
          {
            loading: () => {
              return `Updating Order!`;
            },
            success: (res) => {
              retrieveService();
              return res?.data?.message;
            },
            error: (err) => {
              return err?.message;
            },
          }
        );
      }
};
  return (
    <Dialog
      open={open}
      maxWidth={'md'}
      PaperProps={{
        sx: {
          width: '100%',
        },
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" style={{ fontSize: '1.5rem' }}>
        {packageData?.title} {'>> Items'}
      </DialogTitle>
      <DialogContent>
      <DraggableDataGrid
                    data={formData?.items?.slice()?.sort((a, b) => a.order - b.order) || []}
                    columns={[
                        { field: 'title', headerName: '', width: '100%', renderCell: ({value, row, index}) => {
                          const sourceIndex = formData?.items?.findIndex((item) => {
                            if (row?.id && item?.id) return item.id === row.id;
                            return item?.order === row?.order;
                          });
                          const resolvedIndex = sourceIndex >= 0 ? sourceIndex : index;
                          const rowData = formData?.items?.[resolvedIndex] || row || {};
                          const priceValue = `${rowData?.price ?? ''}`;
                          const hoursValue = `${rowData?.time_hrs ?? ''}`;
                          const discountValue = `${rowData?.discount_value ?? rowData?.discount_amount ?? rowData?.discount_percent ?? ''}`;
                          return <>
                          <Grid key={index} container sx={{ paddingTop: '10px' }}>
                            <Grid item xs={10}>
                              <Grid key={index} container spacing={2}>
                                <Grid item xs={6}>
                                  <TextField
                                    inputProps={{ readOnly: readOnly[resolvedIndex] }}
                                    size="small"
                                    fullWidth
                                    name="title"
                                    value={rowData?.title || ''}
                                    onChange={(e) => handleFormData(e.target.name, e.target.value, resolvedIndex)}
                                    type="text"
                                    label="Title"
                                    error={!validated[resolvedIndex] && (rowData?.title || '') === ''}
                                    helperText={
                                      !validated[resolvedIndex] &&
                                      (rowData?.title || '') === '' &&
                                      'Title is required!'
                                    }
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField
                                    size="small"
                                    fullWidth
                                    name="price"
                                    type="number"
                                    value={priceValue}
                                    onChange={(e) => handleFormData(e.target.name, e.target.value, resolvedIndex)}
                                    inputProps={{ min: 0, readOnly: readOnly[resolvedIndex] }}
                                    label="Cost"
                                    error={
                                      !validated[resolvedIndex] &&
                                      (priceValue === '' || priceValue.includes('-'))
                                    }
                                    helperText={
                                      !validated[resolvedIndex] && priceValue === ''
                                        ? 'Price is required!'
                                        : !validated[resolvedIndex] && priceValue.includes('-')
                                        ? 'Price cannot be negative!'
                                        : ''
                                    }
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField
                                    size="small"
                                    fullWidth
                                    name="time_hrs"
                                    value={hoursValue}
                                    inputProps={{ min: 0, readOnly: readOnly[resolvedIndex] }}
                                    type="number"
                                    label="Hours"
                                    error={
                                      !validated[resolvedIndex] &&
                                      (hoursValue === '' || hoursValue.includes('-'))
                                    }
                                    onChange={(e) => handleFormData(e.target.name, e.target.value, resolvedIndex)}
                                    helperText={
                                      !validated[resolvedIndex] && hoursValue === ''
                                        ? 'Hours are required!'
                                        : !validated[resolvedIndex] && hoursValue.includes('-')
                                        ? 'Hours cannot be negative!'
                                        : ''
                                    }
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  <MuiBox display="flex" gap={1} alignItems="flex-start">
                                    <TextField
                                      size="small"
                                      fullWidth
                                      name="discount_value"
                                      value={discountValue}
                                      inputProps={{ min: 0, readOnly: readOnly[resolvedIndex] }}
                                      type="number"
                                      label="Discount"
                                      error={
                                        !validated[resolvedIndex] &&
                                        (discountValue === '' || discountValue.includes('-') ||
                                          (rowData?.discount_type === 'percentage' && Number(discountValue) > 100))
                                      }
                                      onChange={(e) => handleDiscountValue(e.target.value, resolvedIndex)}
                                      helperText={
                                        !validated[resolvedIndex] && discountValue === ''
                                          ? 'Discount is required!'
                                          : !validated[resolvedIndex] && discountValue.includes('-')
                                          ? 'Discount cannot be negative!'
                                          : !validated[resolvedIndex] && rowData?.discount_type === 'percentage' && Number(discountValue) > 100
                                          ? 'Percentage cannot exceed 100!'
                                          : ''
                                      }
                                    />
                                    <ToggleButtonGroup
                                      exclusive
                                      size="small"
                                      value={rowData?.discount_type || 'percentage'}
                                      onChange={(_, value) => handleDiscountType(value, resolvedIndex)}
                                      aria-label="Discount type"
                                      sx={{
                                        height: 40,
                                        flexShrink: 0,
                                        '& .MuiToggleButton-root': {
                                          minWidth: 36,
                                          padding: '6px 10px',
                                        },
                                      }}
                                    >
                                      <ToggleButton value="fixed" disabled={readOnly[resolvedIndex]} aria-label="Fixed dollar discount">$</ToggleButton>
                                      <ToggleButton value="percentage" disabled={readOnly[resolvedIndex]} aria-label="Percentage discount">%</ToggleButton>
                                    </ToggleButtonGroup>
                                  </MuiBox>
                                </Grid>
                                <Grid item xs={12}>
                                  <TextField
                                    select
                                    size="small"
                                    fullWidth
                                    label="Booking eligibility"
                                    name="eligibility_type"
                                    value={rowData?.eligibility_type || 'all'}
                                    disabled={readOnly[resolvedIndex]}
                                    onChange={(e) => handleFormData(e.target.name, e.target.value, resolvedIndex)}
                                    helperText="Controls which customers may select this item."
                                  >
                                    {ITEM_ELIGIBILITY_OPTIONS.map((option) => (
                                      <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                    ))}
                                  </TextField>
                                </Grid>
                              </Grid>
                            </Grid>
            <Grid 
            container
            item
            xs={2}
            sx={{
              display: 'grid',
              gap: '5px',
              justifyContent: 'center'
            }}
            >
              <Grid
                              item
                              xs={12}
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                '& button': {
                                  minWidth: 'unset !important',
                                  padding: '6px !important',
                                },
                              }}
                            >
                              {readOnly[resolvedIndex] ? (
                                <Button
                                  variant="outlined"
                                  style={{ marginRight: '10px' }}
                                  onClick={() => readOnlyOff(resolvedIndex)}
                                  color="primary"
                                >
                                  <BorderColorOutlinedIcon />
                                </Button>
                              ) : (
                                <Button
                                  variant="outlined"
                                  style={{ marginRight: '10px' }}
                                  onClick={() => saveItem(resolvedIndex, rowData)}
                                  color="primary"
                                >
                                  <SaveOutlinedIcon />
                                </Button>
                              )}
            
                              {formData?.items?.length > 1 && (
                                <Button
                                  variant="outlined"
                                  onClick={() => deleteItems(resolvedIndex, rowData)}
                                  color="error"
                                >
                                  <DeleteOutlineOutlinedIcon />
                                </Button>
                              )}
                              
                            </Grid>
                            <Box display="flex" alignItems="center">
                                   {row?.order}
                                   <DragIndicator style={{ cursor: 'move', marginRight: '8px' }} />
                               </Box>
            </Grid>
                            
                          </Grid>
            
                          {/* {index === formData.items.length - 1 ? null : (
                            <Divider sx={{ mt: 2.5, mb: 1, mx: 'auto' }} />
                          )} */}
                        </>
                        } },
                      ]}
                    onListUpdate={handleListUpdate}
                />

        <Box
          display={'flex'}
          alignItems="center"
          justifyContent={'space-between'}
          sx={{ mb: 2, mt: 3 }}
        >
          <Button variant="text" color="primary" onClick={addMoreItems}>
            Add more item
          </Button>
          <Box>
            <Button
              onClick={() => {
                handleClose();
              }}
              variant="outlined"
              color="primary"
              sx={{ mr: 2 }}
            >
              Cancel
            </Button>
            <LoadingButton
              type="submit"
              color="primary"
              startIcon={<KeyboardArrowRightIcon />}
              loading={false}
              variant="contained"
              onClick={() => {
                retrieveService();
                setTimeout(() => {
                  handleClose();
                }, 200);
              }}
            >
              Save & Close
            </LoadingButton>
          </Box>
        </Box>
      </DialogContent>
      <Toaster position="top-right" />
    </Dialog>
  );
}

export default UpdatePackageItem;
